import React from "react";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";

const BRAND = "#4475a5";

const ParkingStatsChart = ({ stats }) => {
  const totalEntries = stats?.totalEntries || 0;

  return (
    <div className="dashboard-donut-stack">
      <div className="dashboard-donut-meter">
        <CircularProgressbar
          value={100}
          text={`Vehicles: ${totalEntries}`}
          styles={buildStyles({
            textSize: "10px",
            textColor: "#0f172a",
            pathColor: BRAND,
            trailColor: "#e8edf3",
          })}
        />
      </div>
    </div>
  );
};

export default ParkingStatsChart;
